/* eslint-disable no-shadow, no-plusplus, func-names */
/* globals $, data, query_string */
import * as d3 from 'd3'
import Table from 'bam-node-savant-table/table'
import { getPitchTypeColor } from 'bam-node-baseball-savant/utils/pitch-type-colors'
import { guff } from 'bam-node-baseball-savant/utils/guff'
import getShortPitchName from 'bam-node-baseball-savant/utils/get-short-pitch-name.ts'

const armPitches = new Set(['FF', 'SI', 'CH', 'FS', 'FO', 'SC'])
const glovePitches = new Set(['FC', 'CU', 'SL', 'ST', 'SV', 'KN'])

const includedPitches = new Set(data.map((d) => d.pitch_type))

function getTooltipX(val, { pitch_hand, pitch_type, year }) {
    let movementType = Number(val) >= 0 ? 'break' : 'tail'
    if (armPitches.has(pitch_type)) {
        movementType = 'tail'
    } else if (glovePitches.has(pitch_type)) {
        movementType = 'break'
    } else {
        // eslint-disable-next-line no-console
        console.log('UNKNOWN HORIZONTAL PITCH', pitch_type)
    }

    const direction = Number(val) >= 0 ? 'more' : 'less'

    // fix formatting
    const absValue = Math.abs(val).toFixed(1)

    const text = `${absValue}&quot; ${direction} ${movementType} vs ${year} ${pitch_hand}HP`

    return text
}

const dropPitches = new Set([
    'SI',
    'CU',
    'SL',
    'ST',
    'SV',
    'KN',
    'CH',
    'FS',
    'FO',
    'SC',
])
const risePitches = new Set(['FF', 'FC'])

function getTooltipZ(val, { pitch_hand, pitch_type, year }) {
    let movementType = Number(val) >= 0 ? 'rise' : 'drop'
    const direction = Number(val) > 0 ? 'more' : 'less'
    if (dropPitches.has(pitch_type)) {
        movementType = 'drop'
        // More drop
    } else if (risePitches.has(pitch_type)) {
        movementType = 'rise'
    } else {
        // eslint-disable-next-line no-console
        console.log('UNKNOWN PITCH', pitch_type)
    }

    const absValue = Math.abs(Number(val)).toFixed(1)
    const pitcherType = `${pitch_hand}HP`
    // return `
    // <span style="background-color: ${color}; padding: 1px 3px; color: ${textColor}; font-size: 11px; font-weight: bold; border: 0.5px solid rgba(0, 0, 0, 0.2);">${absValue}"</span> ${direction} ${movementType} vs AVG`

    const text = `${absValue}&quot; ${direction} ${movementType} vs ${year} ${pitcherType}`

    return text
}
let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'movementLeaderboard'

$(document).ready(() => {
    $('#ddlHand').change(() => {
        $('#lblHand').html($('#ddlHand option:selected').text())
    })
    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason option:selected').text())
    })

    $('#ddlX').change(() => {
        $('#lblX').html($('#ddlX option:selected').text())
    })

    $('#ddlZ').change(() => {
        $('#lblZ').html($('#ddlZ option:selected').text())
    })

    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
    })
    $('#ddlMin').change(() => {
        $('#lblMin').html(`Minimum Pitches (${$('#ddlMin').val()})`)
    })

    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html(`Minimum Pitches (${$('#ddlMin').val()})`)
    }
    if (query_string.hand) {
        $('#ddlHand').val(query_string.hand).attr('selected', true)
        $('#lblHand').html($('#ddlHand option:selected').text())
    }

    if (query_string.year) {
        $('#ddlSeason').val(query_string.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason option:selected').text())
    }

    $('#lblType').html($('#ddlType option:selected').text())

    if (query_string.x) {
        $('#ddlX').val(query_string.x).attr('selected', true)
        $('#lblX').html($('#ddlX option:selected').text())
    }
    if (query_string.z) {
        $('#ddlZ').val(query_string.z).attr('selected', true)
        $('#lblZ').html($('#ddlZ option:selected').text())
    }
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    $('form').submit(false)

    if (data && data.length > 0) {
        const headers = [
            {
                name: 'Pitcher',
                field: 'href',
                customSortField: 'pitcher_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'pitcher_id',
            },
            {
                name: 'Team',
                field: 'team_name_abbrev',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                photoId: 'team_id',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoOnly: true,
            },
            {
                name: 'Hand',
                field: 'pitch_hand',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Pitch',
                field: 'pitch_type_name',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: '#',
                field: 'pitches_thrown',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'MPH',
                field: 'avg_speed',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'pitch_velocity'),
            },
            {
                name: 'Vertical<br/>Drop',
                field: 'pitcher_break_z',
                type: 'number',
                headerClass:
                    'th-component-header align-center th-vertical-bottom border-left',
                fieldClass: 'tr-data align-center border-left',
                displayFn: (val) => guff(val, 'movement_vertical_'),
            },
            {
                name: 'vs.<br/>Comparable',
                field: 'diff_z',
                type: 'number',
                headerClass:
                    'th-component-header th-vertical-bottom align-center',
                fieldClass: 'tr-data align-center',
                highlight: [0, 0.5, 1],
                rankColumn: 'percent_rank_diff_z',
                toolTip:
                    'Compared to pitches within 2 mph, 0.5 feet of extension/release',
                // FIX
                displayFn: (val) => guff(val, 'movement_vertical_'),
            },
            {
                name: 'Horizontal<br/>Break',
                field: 'pitcher_break_x_hidden',
                type: 'number',
                headerClass:
                    'th-component-header th-vertical-bottom align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => {
                    const armGlv = val < 0 ? 'ARM' : 'GLV'
                    const formatted = guff(
                        Math.abs(val),
                        'movement_horizontal_'
                    )
                    return `${formatted}<span class="arm-glv-label">${armGlv}</span>`
                },
            },
            {
                name: 'vs.<br/>Comparable',
                field: 'diff_x',
                type: 'number',
                headerClass:
                    'th-component-header th-vertical-bottom align-center',
                fieldClass: 'tr-data align-center',
                highlight: [0, 0.5, 1],
                rankColumn: 'percent_rank_diff_x',
                toolTip:
                    'Compared to pitches within 2 mph, 0.5 feet of extension/release',
                // FIX
                displayFn: (val) => guff(val, 'movement_vertical_'),
            },
            {
                name: 'Vertical<br/>Break',
                field: 'pitcher_break_z_induced',
                type: 'number',
                headerClass:
                    'th-component-header align-center th-vertical-bottom border-left',
                fieldClass: 'tr-data align-center border-left',
                toolTip:
                    'Vertical Rise/Drop compared to an equivalent pitch only affected by gravity',
                displayFn: (val) => guff(val, 'movement_vertical_'),
            },
            {
                name: 'vs. Avg',
                field: 'diff_z_induced_standard',
                type: 'number',
                headerClass:
                    'th-component-header th-vertical-bottom align-center',
                fieldClass: 'tr-data align-center',
                toolTip: 'Compared to all same handed pitchers',
                // FIX
                displayFn: (val, row) => {
                    // fix
                    const formatted = guff(val, 'movement_vertical_')

                    const tooltip = getTooltipZ(formatted, row)
                    return `<span title="${tooltip}">${formatted}</span>`
                },
            },
            {
                name: 'Horizontal<br/>Break',
                field: 'pitcher_break_x_hidden',
                type: 'number',
                headerClass:
                    'th-component-header th-vertical-bottom align-center',
                fieldClass: 'tr-data align-center',
                toolTip:
                    "Pitches move horizontally either in the direction of the pitcher's glove side or arm side.",
                displayFn: (val) => {
                    const armGlv = val < 0 ? 'ARM' : 'GLV'
                    const formatted = guff(
                        Math.abs(val),
                        'movement_horizontal_'
                    )
                    return `${formatted}<span class="arm-glv-label">${armGlv}</span>`
                },
            },
            {
                name: 'vs. Avg',
                field: 'diff_x_standard',
                type: 'number',
                headerClass:
                    'th-component-header th-vertical-bottom align-center border-right',
                fieldClass: 'tr-data align-center border-right',
                toolTip: 'Compared to all same handed pitchers',
                // FIX
                displayFn: (val, row) => {
                    // fix
                    const formatted = guff(val, 'movement_vertical_')

                    const tooltip = getTooltipX(formatted, row)
                    return `<span title="${tooltip}">${formatted}</span>`
                },
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        const { sort, sortDir } = query_string
        const numSort = Number(sort)
        // Previously URLs had a sort query param as an index, attempt to fix that
        // Currently will not accurately work if we move columns one day, but I'm okay with that.
        const sortField = Number.isNaN(numSort)
            ? sort
            : headers[sort].customSortField || headers[sort].field

        const sortDirection = ['asc', 'desc'].includes(sortDir)
            ? sortDir
            : 'desc'

        // eslint-disable-next-line no-new
        new Table({
            id: 'movementLeaderboard',
            repeatHeader: repeatHeaders,
            secondaryHeaders: [
                {
                    name: '',
                    colspan: 7,
                    headerClass: 'th-name-header',
                },
                {
                    name: 'Total Movement (in inches, w/ gravity)',
                    colspan: 4,
                    headerClass: 'th-title-header border-right',
                },
                {
                    name: 'Induced Movement (in inches, w/o gravity)',
                    colspan: 4,
                    headerClass: 'th-title-header',
                },
            ],

            headers,
            data,
            showRank: true,
            defaultSort: sortField,
            defaultSortDirection: sortDirection,
            sortClass: 'column-sort',
            highlightNullish: false,
            sortCallback(column, _, { state }) {
                const url = new URL(window.location)
                url.searchParams.set('sort', column)
                url.searchParams.set('sortDir', state)
                window.history.replaceState('', '', url.toString())
            },
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#btnUpdate').click(() => {
        window.location.href = populateUrl()
    })
    $('#btnCSV').click(() => {
        window.location.href = `${populateUrl()}&csv=true`
    })

    createChart()

    $('#pt-legend .type').on('mouseover', function () {
        const type = this.id.split('_')[1]
        d3.selectAll('.circles').classed('circle-hide', true)

        d3.selectAll(`.${type}`).classed('circle-hide', false).raise()
    })

    $('#pt-legend .type').on('mouseout', () => {
        d3.selectAll('.circles').classed('circle-hide', false)
    })

    $(document).on('click', 'th.th-component-header', () => {
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
    })
})

window.addEventListener('scroll', () => {
    if (!ticking && data.length) {
        window.requestAnimationFrame(() => {
            checkHeaderPosition(tableDivId)
            ticking = false
        })

        ticking = true
    }
})

function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} table thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

function addStaticHeader(divId) {
    const width = $(`#${divId}`).outerWidth()
    // $(".tr-component-row th").removeClass("column-sort");

    if (width && width > 767) {
        // console.log(width);
        let tableCell = 0

        // Set TH Width before applying fixed-header
        $('.default-table-row')
            .first()
            .children('td')
            .each(function () {
                const width = $(this).outerWidth()
                $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                    'width',
                    width
                )
                tableCell++
            })

        $(`#${divId} table thead`).addClass('fixed-header')
        tableCell = 0

        // Set TD Width before applying fixed-header
        $('.tr-component-row')
            .children('th')
            .each(function () {
                const width = $(this).outerWidth()
                $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                    'width',
                    width
                )
                tableCell++
            })
    }
}

window.addEventListener('resize', () => {
    if (isFixedHeaderShowing) {
        addStaticHeader(tableDivId)
    }
})

function populateUrl() {
    const url = new URL(window.location)

    url.searchParams.set('year', document.getElementById('ddlSeason').value)
    url.searchParams.set('min', document.getElementById('ddlMin').value)
    url.searchParams.set('pitch_type', document.getElementById('ddlType').value)
    url.searchParams.set('hand', document.getElementById('ddlHand').value)

    return String(url)
}

function createLegendType(type) {
    const color = getPitchTypeColor(type)
    const isIncluded = includedPitches.has(type)

    return `
        <div
            id="type_${type}"
            class="type"
            style="color: ${color}; opacity: ${isIncluded ? 1 : 0.2}"
        >
            ${getShortPitchName(type)}
        </div>
    `
}
function createLegend(width) {
    $('#pt-legend').show()
    $('#pt-legend').append(
        `<div style="font-family: 'Roboto Condensed';
            display: flex; text-align: left;
            justify-content: center;
            padding-left: 20px;
            padding-bottom: 10px;
            gap: 10px;
            margin: 0 auto 20px; width: ${width}px;">` +
            `<div>
                ${createLegendType('FF')}
                ${createLegendType('SI')}
                ${createLegendType('FC')}
            </div>
            <div>
                ${createLegendType('CU')}
                ${createLegendType('SL')}
                ${createLegendType('ST')}
                ${createLegendType('SV')}
            </div>
            <div>
                ${createLegendType('CH')}
                ${createLegendType('FS')}
                ${createLegendType('FO')}
                ${createLegendType('SC')}
            </div>
            <div>
                ${createLegendType('KN')}
            </div>
        </div><div style="clear: both;"></div>`
    )
}

function createChart() {
    if (!data.length) {
        return
    }

    let size = $('#movementLeaderboard').width() || 500

    if (size >= 500) {
        size = 500
    }
    if (size < 330) {
        size = 330
    }

    const margin = { top: 80, right: 50, bottom: 80, left: 70 }
    const width = size - margin.left - margin.right
    const height = size - margin.top - margin.bottom

    const x = d3.scaleLinear().range([0, width])
    const y = d3.scaleLinear().range([height, 0])

    let svg = d3
        .select('#movement_chart')
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)

    svg.append('svg:defs')
        .append('svg:marker') // This section adds in the arrows
        .attr('id', 'end')
        .attr('viewBox', '0 -5 10 10')
        .attr('markerUnits', 'strokeWidth')
        .attr('markerWidth', 6)
        .attr('markerHeight', 6)
        .attr('orient', 'auto')
        .attr('fill', '#000')
        .append('svg:path')
        .attr('d', 'M0,-5L10,0L0,5')

    svg.append('rect')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('fill', '#e4f2f5')

    svg = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

    svg.append('text')
        .attr('transform', `translate(${width / 2} ,-20)`)
        .style('font-size', '1.4rem')
        .attr('text-anchor', 'middle')
        .style('fill', '#3a9098')
        .text(`${$('#ddlType option:selected').text()} Movement`)

    const xVal = d3.select('#ddlX').node().value
    const yVal = d3.select('#ddlZ').node().value

    x.domain(d3.extent(data, (d) => Number(d[xVal])))
    y.domain(d3.extent(data, (d) => Number(d[yVal])))

    const xAxis = svg
        .append('g')
        .attr('transform', `translate(0,${height})`)
        .call(createXAxisFn(xVal, x))

    const xLabel = svg.append('g')

    xLabel
        .append('text')
        .attr('id', 'xLabel')
        .attr(
            'transform',
            `translate(${width / 2} ,${height + margin.bottom / 2})`
        )
        .style('text-anchor', 'middle')
        .style('font-size', '1rem')
        .text(d3.select('#ddlX option:checked').text())

    xLabel
        .append('path')
        .attr(
            'transform',
            `translate(${width / 1.35} ,${height + margin.bottom / 1.3})`
        )
        .attr('d', `M0,0 L${width / 4},0`)
        .attr('marker-end', 'url(#end)')
        .attr('fill', '#000')
        .attr('stroke', '#000')

    xLabel
        .append('text')
        .attr(
            'transform',
            `translate(${width / 1.15} ,${height + margin.bottom / 1.05})`
        )
        .style('text-anchor', 'middle')
        .style('font-size', '12px')
        .style('fill', '#3a9098')
        .text('More Break')

    xLabel
        .append('path')
        .attr('transform', `translate(0,${height + margin.bottom / 1.3})`)
        .attr('d', `M${width / 4},0 L10,0`)
        .attr('marker-end', 'url(#end)')
        .attr('fill', '#000')
        .attr('stroke', '#000')

    xLabel
        .append('text')
        .attr(
            'transform',
            `translate(${width * 0.125} ,${height + margin.bottom / 1.05})`
        )
        .style('text-anchor', 'middle')
        .style('font-size', '.8rem')
        .style('fill', '#3a9098')
        .text('Less Break')

    // Add the Y Axis
    const yAxis = svg.append('g').call(createYAxisFn(yVal, y))

    const yLabel = svg.append('g')

    yLabel
        .append('text')
        .attr('id', 'yLabel')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - (margin.left * 3) / 4)
        .attr('x', 0 - height / 2)
        .attr('dy', '1em')
        .style('text-anchor', 'middle')
        .style('font-size', '1rem')
        .text(d3.select('#ddlZ option:checked').text())

    yLabel
        .append('path')
        .attr('transform', `translate(${-(margin.left / 1.4)},${height / 1.3})`)
        .attr('d', `M0,0 L0,${height * 0.2}`)
        .attr('marker-end', 'url(#end)')
        .attr('fill', '#000')
        .attr('stroke', '#000')

    yLabel
        .append('text')
        .attr('id', 'yLabel')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - (margin.left + 2.5))
        .attr('x', 0 - height / 1.24)
        .attr('dy', '1em')
        .style('text-anchor', 'end')
        .style('font-size', '.8rem')
        .style('fill', '#3a9098')
        .text('More "Drop"')

    yLabel
        .append('path')
        .attr('transform', `translate(${-(margin.left / 1.3)},${0})`)
        .attr('d', `M0,${height / 4.5} L0,10`)
        .attr('marker-end', 'url(#end)')
        .attr('fill', '#000')
        .attr('stroke', '#000')

    yLabel
        .append('text')
        .attr('id', 'yLabel')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - (margin.left + 2.5))
        .attr('x', 0 - height * 0.05)
        .attr('dy', '1em')
        .style('text-anchor', 'end')
        .style('font-size', '12px')
        .style('fill', '#3a9098')
        .text('More "Rise"')

    // Add the scatterplot
    svg.selectAll('dot')
        .data(data, (d) => d)
        .enter()
        .append('circle')
        .attr('class', (d) => `circles ${d.pitch_type}`)
        .attr('r', 3)
        .attr('opacity', 0.75)
        .attr('cx', (d) => x(Number(d[xVal])))
        .attr('cy', (d) => y(Number(d[yVal])))
        .attr('fill', (d) => getPitchTypeColor(d.pitch_type))
        .attr('stroke', '#000')
        .on('mouseover', (event, d) => {
            const tooltip = d3
                .select('body')
                .append('div')
                .attr('id', `tooltip_${d.pitcher_id}`)
                .attr('class', 'tooltip')
                .style('opacity', 1)
            const html =
                `<div style="width: 320px; line-height: 1.4rem;">` +
                `<div style="float: left; width: 70px;"><div class="player-image">` +
                `<img onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" src="https://content.mlb.com/images/headshots/current/60x60/${d.pitcher_id}.png" />` +
                `</div></div>` +
                `<div style="float: left; width: 200px; font-family: 'Roboto Condensed'; font-size: 14px;">` +
                `<b><span style=" font-size: 16px;">${d.pitcher_name}</span></b><br/>${d.pitch_type_name}<br/>` +
                `</div>`
            tooltip
                .html(html)
                .style('left', `${event.pageX + 5}px`)
                .style('top', `${event.pageY - 28}px`)
        })
        .on('mouseout', (event, d) => {
            d3.select(`#tooltip_${d.pitcher_id}`).style('opacity', 0)
            $(`#tooltip_${d.pitcher_id}`).hide()
            $(`#tooltip_${d.pitcher_id}`).remove()
        })
    if ($('#ddlType').val() === 'ALL') {
        createLegend(width)
    }

    function createXAxisFn(xVal, x) {
        const xAxisFn = d3.axisBottom(x).ticks(4).tickSize(-height)

        if (xVal === 'pitch_per') {
            xAxisFn.tickFormat(d3.format('.0%'))
        }

        return xAxisFn
    }

    function createYAxisFn(yVal, y) {
        const yAxisFn = d3.axisLeft(y).ticks(4).tickSize(-width)

        if (yVal === 'pitch_per') {
            yAxisFn.tickFormat(d3.format('.0%'))
        }

        return yAxisFn
    }

    function update() {
        const xVal = d3.select('#ddlX').node().value
        const yVal = d3.select('#ddlZ').node().value

        // Scale the range of the data
        x.domain(d3.extent(data, (d) => Number(d[xVal])))
        y.domain(d3.extent(data, (d) => Number(d[yVal])))

        yAxis.transition().duration(700).call(createYAxisFn(yVal, y))

        svg.selectAll('#xLabel').text(d3.select('#ddlX option:checked').text())

        xAxis.transition().duration(700).call(createXAxisFn(xVal, x))

        yLabel.select('#yLabel').text(d3.select('#ddlZ option:checked').text())

        const tempData = data

        const p = svg.selectAll('.circles').data(tempData)

        p.enter()
            .append('circle')
            .attr('r', 3)
            .attr('class', 'circles')
            .attr('fill', (d) => getPitchTypeColor(d.pitch_type))
            .attr('stroke', '#000')
            .attr('opacity', 0.75)
            .attr('cx', (d) => x(Number(d[xVal])))
            .attr('cy', (d) => y(Number(d[yVal])))

        // Update
        p.transition()
            .duration(700)
            .attr('cx', (d) => x(Number(d[xVal])))
            .attr('cy', (d) => y(Number(d[yVal])))
            .attr('fill', (d) => getPitchTypeColor(d.pitch_type))

        // Exit
        p.exit().transition().duration(500).attr('opacity', '0').remove()
    }

    $('.chartChange').change(() => {
        // Update Url
        const url = new URL(window.location)

        url.searchParams.set('x', document.getElementById('ddlX').value)
        url.searchParams.set('z', document.getElementById('ddlZ').value)
        window.history.replaceState('', '', String(url))

        // Update Chart
        update()
    })
}
